import React from "react";

import SharedEmptyState from "../../../../components/EmptyState";

/**
 * Format Empty State Component
 * Matches Figma design exactly - bracket cards layout with organic blob background
 */
const EmptyState = ({ onCreateFormat }) => {
  return (
    <SharedEmptyState
      illustration={<FormatIllustration />}
      heading="Ready to design your competition format?"
      description={onCreateFormat ? "Start quickly with templates, or customize everything from scratch." : "Only admins and owners can create the competition format."}
      className="pt-6"
      actions={
        onCreateFormat ? (
          <button
            className="w-[343px] h-11 bg-[#00E7FF] text-[#021529] rounded-full font-medium text-[15px] hover:opacity-50 transition-opacity"
            onClick={onCreateFormat}
          >
            Create format
          </button>
        ) : null
      }
    />
  );
};

/**
 * Blob illustration with bracket card placeholders (from Figma)
 */
const FormatIllustration = () => {
  const scale = 0.85;

  const TeamRow = () => (
    <div className="flex items-center" style={{ gap: `${4.973 * scale}px` }}>
      <div
        className="shrink-0 rounded-full"
        style={{
          width: `${24.865 * scale}px`,
          height: `${24.865 * scale}px`,
          background: "#4C565D",
          border: "1px solid #26333D",
          boxSizing: "border-box",
        }}
      />
      <img
        src="/icons/Frame 26776.svg"
        alt=""
        className="shrink-0"
        style={{
          width: `${62.162 * scale}px`,
          height: `${19.892 * scale}px`,
        }}
      />
    </div>
  );

  return (
    <div
      className="relative"
      style={{ width: `${532 * scale}px`, height: `${361 * scale}px` }}
    >
      {/* Background blob shape */}
      <svg
        className="absolute inset-0"
        width={532 * scale}
        height={361 * scale}
        viewBox="0 0 532 361"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid meet"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M268.354 2.08732C322.038 -6.37381 375.714 11.5621 419.584 43.6889C472.293 82.2896 532.597 129.762 531.996 195.159C531.396 260.373 472.608 310.229 416.824 343.866C372.642 370.507 319.647 359.488 268.354 354.133C224.797 349.585 185.606 338.123 147.915 315.789C91.0432 282.089 -2.89014 261.278 0.0682295 195.159C3.05815 128.336 104.011 123.909 158.247 84.8777C196.992 56.9947 221.224 9.51532 268.354 2.08732Z"
          fill="#081725"
        />
      </svg>

      {/* Bracket cards */}
      <div
        className="absolute z-10"
        style={{
          left: `${63 * scale}px`,
          top: `${71 * scale}px`,
          width: `${469 * scale}px`,
          height: `${225 * scale}px`,
        }}
      >
        {/* Top left card */}
        <div
          className="absolute overflow-hidden"
          style={{
            left: `${64.95 * scale}px`,
            top: 0,
            paddingLeft: `${9.946 * scale}px`,
            paddingRight: `${94.486 * scale}px`,
            paddingTop: `${12.432 * scale}px`,
            paddingBottom: `${12.432 * scale}px`,
            background: "#192634",
            borderRadius: `${9.946 * scale}px`,
          }}
        >
          <TeamRow />
        </div>

        {/* Bottom left card */}
        <div
          className="absolute overflow-hidden"
          style={{
            left: 0,
            top: `${175.3 * scale}px`,
            paddingLeft: `${9.946 * scale}px`,
            paddingRight: `${94.486 * scale}px`,
            paddingTop: `${12.432 * scale}px`,
            paddingBottom: `${12.432 * scale}px`,
            background: "#192634",
            borderRadius: `${9.946 * scale}px`,
          }}
        >
          <TeamRow />
        </div>

        {/* Center card - 4 team rows */}
        <div
          className="absolute flex flex-col overflow-hidden"
          style={{
            left: `${109.7 * scale}px`,
            top: `${46 * scale}px`,
            paddingLeft: `${9.946 * scale}px`,
            paddingRight: `${94.486 * scale}px`,
            paddingTop: `${12.432 * scale}px`,
            paddingBottom: `${12.432 * scale}px`,
            background: "#26333D",
            borderRadius: `${9.946 * scale}px`,
            gap: `${9.946 * scale}px`,
          }}
        >
          <TeamRow />
          <TeamRow />
          <TeamRow />
          <TeamRow />
        </div>

        {/* Right card - 2 team rows */}
        <div
          className="absolute flex flex-col overflow-hidden"
          style={{
            left: `${272.56 * scale}px`,
            top: `${59.67 * scale}px`,
            paddingLeft: `${9.946 * scale}px`,
            paddingRight: `${94.486 * scale}px`,
            paddingTop: `${12.432 * scale}px`,
            paddingBottom: `${12.432 * scale}px`,
            background: "#333E48",
            borderRadius: `${9.946 * scale}px`,
            gap: `${9.946 * scale}px`,
          }}
        >
          <TeamRow />
          <TeamRow />
        </div>
      </div>
    </div>
  );
};

export default EmptyState;
